var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './search.component.less';
import './search.compact.component.less';
import './search.classic.component.less';
import _, { clone, cloneDeep, compact, extend, includes, intersection, isArray, isEmpty, isEqual, isNumber, isString, isUndefined, map, throttle, union } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { element } from 'angular';
import 'angular-material';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
import '@stratusjs/angularjs-extras';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'property';
const componentName = 'search';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxPropertySearch = {
    bindings: {
        elementId: '@',
        initNow: '=',
        tokenUrl: '@',
        tokenOnLoad: '@',
        listId: '@',
        listLinkUrl: '@',
        listLinkTarget: '@',
        searchType: '@',
        advancedSearchUrl: '@',
        advancedSearchLinkName: '@',
        template: '@',
        options: '@',
        optionsAgentGroups: '@',
        optionsOfficeGroups: '@',
        displayFilterFullHeight: '@',
        variableSync: '@',
        widgetName: '@'
    },
    controller($attrs, $element, $q, $mdConstant, $mdDialog, $mdPanel, $sce, $scope, $timeout, $window, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        $scope._ = _;
        Stratus.Instances[$scope.elementId] = $scope;
        $scope.localDir = localDir;
        $scope.initialized = false;
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
        }
        Stratus.Internals.CssLoader(localDistStyle).then();
        let defaultQuery;
        let lastQuery;
        let mlsVariables;
        $scope.openPrice = false;
        $scope.advancedFiltersStatus = false;
        $scope.advancedSearchUrl = '';
        $scope.advancedSearchLinkName = 'Advanced Search';
        $scope.presetLocationText = '';
        $scope.$mdConstant = $mdConstant;
        const init = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            var _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
            $scope.widgetName = $attrs.widgetName || '';
            $scope.listId = $attrs.listId || null;
            $scope.listInitialized = false;
            $scope.listLinkUrl = $attrs.listLinkUrl || $attrs.advancedSearchUrl || '/property/list';
            $scope.listLinkTarget = $attrs.listLinkTarget || '_self';
            $scope.searchType = $attrs.searchType || 'advanced';
            $scope.advancedSearchUrl = $attrs.advancedSearchUrl || $scope.advancedSearchUrl;
            $scope.advancedSearchLinkName = $attrs.advancedSearchLinkName || $scope.advancedSearchLinkName;
            $scope.options = $attrs.options && isJSON($attrs.options) ? JSON.parse($attrs.options) : {};
            $scope.displayFilterFullHeight = $attrs.displayFilterFullHeight && isJSON($attrs.displayFilterFullHeight) ?
                JSON.parse($attrs.displayFilterFullHeight) : false;
            $scope.filterMenu = null;
            (_r = $scope.options).forRent || (_r.forRent = false);
            (_a = (_s = $scope.options).agentGroups) !== null && _a !== void 0 ? _a : (_s.agentGroups = []);
            $scope.options.officeGroups =
                ($scope.options.officeGroups && isString($scope.options.officeGroups) && isJSON($scope.options.officeGroups)
                    ? JSON.parse($scope.options.officeGroups)
                    : ($attrs.optionsOfficeGroups && isJSON($attrs.optionsOfficeGroups)
                        ? JSON.parse($attrs.optionsOfficeGroups)
                        : $scope.options.officeGroups)) || [];
            (_b = (_t = $scope.options).query) !== null && _b !== void 0 ? _b : (_t.query = {});
            (_c = (_u = $scope.options.query).where) !== null && _c !== void 0 ? _c : (_u.where = {});
            (_d = (_v = $scope.options.query).service) !== null && _d !== void 0 ? _d : (_v.service = []);
            $scope.setWhere($scope.options.query.where);
            defaultQuery = JSON.parse(JSON.stringify(cloneDeep($scope.options.query.where)));
            if ($scope.options.query.order) {
                defaultQuery.Order = $scope.options.query.order;
            }
            $timeout(() => __awaiter(this, void 0, void 0, function* () {
                yield $scope.variableSync();
            }), 1000);
            (_e = (_w = $scope.options).selection) !== null && _e !== void 0 ? _e : (_w.selection = {});
            (_f = (_x = $scope.options.selection).Bedrooms) !== null && _f !== void 0 ? _f : (_x.Bedrooms = [
                { name: '1+', value: 1 },
                { name: '2+', value: 2 },
                { name: '3+', value: 3 },
                { name: '4+', value: 4 },
                { name: '5+', value: 5 }
            ]);
            (_g = (_y = $scope.options.selection).Bathrooms) !== null && _g !== void 0 ? _g : (_y.Bathrooms = [
                { name: '1+', value: 1 },
                { name: '2+', value: 2 },
                { name: '3+', value: 3 },
                { name: '4+', value: 4 },
                { name: '5+', value: 5 }
            ]);
            (_h = (_z = $scope.options.selection).order) !== null && _h !== void 0 ? _h : (_z.order = [
                { name: 'Highest Price', value: '-BestPrice' },
                { name: 'Lowest Price', value: 'BestPrice' },
                { name: 'Recently Updated', value: '-ModificationTimestamp' },
                { name: 'Recently Sold', value: '-CloseDate' },
                { name: 'Status + Price', value: ['Status', '-BestPrice'] },
                { name: 'Status + Recent', value: ['Status', '-ModificationTimestamp'] }
            ]);
            (_j = (_0 = $scope.options.selection).Status) !== null && _j !== void 0 ? _j : (_0.Status = {});
            (_k = (_1 = $scope.options.selection.Status).default) !== null && _k !== void 0 ? _k : (_1.default = {
                Sale: ['Active', 'Contract'],
                Lease: ['Active']
            });
            (_l = (_2 = $scope.options.selection).ListingType) !== null && _l !== void 0 ? _l : (_2.ListingType = {});
            (_m = (_3 = $scope.options.selection.ListingType).group) !== null && _m !== void 0 ? _m : (_3.group = {
                Residential: true,
                Commercial: false
            });
            (_o = (_4 = $scope.options.selection.ListingType).list) !== null && _o !== void 0 ? _o : (_4.list = {
                Residential: ['House', 'Condo', 'Townhouse', 'MultiFamily', 'Manufactured', 'Land', 'LeaseHouse', 'LeaseCondo', 'LeaseTownhouse', 'LeaseOther'],
                Commercial: ['Commercial', 'CommercialBusinessOp', 'CommercialResidential', 'CommercialLand', 'LeaseCommercial'],
                Lease: ['LeaseHouse', 'LeaseCondo', 'LeaseTownhouse', 'LeaseOther', 'LeaseCommercial']
            });
            (_p = (_5 = $scope.options.selection.ListingType).default) !== null && _p !== void 0 ? _p : (_5.default = {
                Sale: {
                    Residential: ['House', 'Condo', 'Townhouse'],
                    Commercial: ['Commercial', 'CommercialBusinessOp']
                },
                Lease: {
                    Residential: ['LeaseHouse', 'LeaseCondo', 'LeaseTownhouse'],
                    Commercial: ['LeaseCommercial']
                }
            });
            (_q = (_6 = $scope.options.selection.ListingType).All) !== null && _q !== void 0 ? _q : (_6.All = [
                { name: 'House', value: 'House', group: 'Residential', lease: false },
                { name: 'Condo', value: 'Condo', group: 'Residential', lease: false },
                { name: 'Townhouse', value: 'Townhouse', group: 'Residential', lease: false },
                { name: 'Multi-Family', value: 'MultiFamily', group: 'Residential', lease: false },
                { name: 'Manufactured', value: 'Manufactured', group: 'Residential', lease: false },
                { name: 'Land', value: 'Land', group: 'Residential', lease: false },
                { name: 'Other', value: 'Other', group: 'Residential', lease: false },
                { name: 'Commercial', value: 'Commercial', group: 'Commercial', lease: false },
                { name: 'Commercial Business Op', value: 'CommercialBusinessOp', group: 'Commercial', lease: false },
                { name: 'Commercial Residential', value: 'CommercialResidential', group: 'Commercial', lease: false },
                { name: 'Commercial Land', value: 'CommercialLand', group: 'Commercial', lease: false },
                { name: 'House', value: 'LeaseHouse', group: 'Residential', lease: true },
                { name: 'Condo', value: 'LeaseCondo', group: 'Residential', lease: true },
                { name: 'Townhouse', value: 'LeaseTownhouse', group: 'Residential', lease: true },
                { name: 'Other', value: 'LeaseOther', group: 'Residential', lease: true },
                { name: 'Commercial', value: 'LeaseCommercial', group: 'Commercial', lease: true }
            ]);
            $scope.setWhereDefaults();
            Idx.registerSearchInstance($scope.elementId, moduleName, $scope, $scope.listId);
            if ($scope.listId) {
                Idx.on($scope.listId, 'init', $scope.refreshSearchWidgetOptions);
                Idx.on($scope.listId, 'searching', $scope.refreshSearchWidgetOptions);
            }
            if ($attrs.tokenOnLoad) {
                try {
                    yield Idx.tokenKeepAuth();
                    $scope.getMLSVariables(true);
                }
                catch (e) {
                    console.error('Search is unable to load in token data', e);
                }
            }
            $scope.$applyAsync(() => {
                $scope.initialized = true;
            });
            Idx.emit('init', $scope);
        });
        this.$onInit = () => {
            $scope.Idx = Idx;
            let initNow = true;
            if (Object.prototype.hasOwnProperty.call($attrs.$attr, 'initNow')) {
                initNow = isJSON($attrs.initNow) ? JSON.parse($attrs.initNow) : false;
            }
            if (initNow) {
                init().then();
                return;
            }
            const stopWatchingInitNow = $scope.$watch('$ctrl.initNow', (initNowCtrl) => {
                if (initNowCtrl !== true) {
                    return;
                }
                if (!$scope.initialized) {
                    init().then();
                }
                stopWatchingInitNow();
            });
        };
        $scope.$watch('options.query.where.ListingType', () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (((_b = (_a = $scope.options) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.where) && ((_e = (_d = (_c = $scope.options) === null || _c === void 0 ? void 0 : _c.selection) === null || _d === void 0 ? void 0 : _d.ListingType) === null || _e === void 0 ? void 0 : _e.list)) {
                if (!((_h = (_g = (_f = $scope.options) === null || _f === void 0 ? void 0 : _f.query) === null || _g === void 0 ? void 0 : _g.where) === null || _h === void 0 ? void 0 : _h.ListingType)) {
                    $scope.options.query.where.ListingType = [];
                }
                if (!isArray($scope.options.query.where.ListingType)) {
                    $scope.options.query.where.ListingType = [$scope.options.query.where.ListingType];
                }
                $scope.options.selection.ListingType.group.Residential =
                    $scope.isIntersecting($scope.options.selection.ListingType.list.Residential, $scope.options.query.where.ListingType);
                $scope.options.selection.ListingType.group.Commercial =
                    $scope.isIntersecting($scope.options.selection.ListingType.list.Commercial, $scope.options.query.where.ListingType);
                $scope.options.forRent =
                    $scope.isIntersecting($scope.options.selection.ListingType.list.Lease, $scope.options.query.where.ListingType);
            }
        });
        $scope.resetLocationQuery = () => {
            $scope.options.query.where.Location = '';
            $scope.options.query.where.eLocation = '';
            $scope.options.query.where.UnparsedAddress = [];
            $scope.options.query.where.StreetAddress = [];
            $scope.options.query.where.eStreetAddress = [];
            $scope.options.query.where.City = [];
            $scope.options.query.where.eCity = [];
            $scope.options.query.where.CountyOrParish = [];
            $scope.options.query.where.eCountyOrParish = [];
            $scope.options.query.where.MLSAreaMajor = [];
            $scope.options.query.where.eMLSAreaMajor = [];
            $scope.options.query.where.Neighborhood = [];
            $scope.options.query.where.eNeighborhood = [];
            $scope.options.query.where.PostalCode = [];
            $scope.options.query.where.ListingId = [];
            $scope.options.query.where.AgentLicense = [];
            $scope.options.query.where.OfficeNumber = [];
            $scope.options.officeGroups = [];
            $scope.parsePresetLocationText();
        };
        $scope.getPresetLocations = () => {
            const currentWhere = $scope.options.query.where;
            return compact(union(currentWhere.UnparsedAddress, currentWhere.StreetAddress, currentWhere.eStreetAddress, currentWhere.City, currentWhere.eCity, currentWhere.CountyOrParish, currentWhere.eCountyOrParish, currentWhere.MLSAreaMajor, currentWhere.eMLSAreaMajor, currentWhere.Neighborhood, currentWhere.eNeighborhood, currentWhere.PostalCode));
        };
        $scope.getOtherPresetFilterCount = () => {
            const currentWhere = $scope.options.query.where;
            let filterCounts = compact(union(currentWhere.OfficeNumber, currentWhere.AgentLicense, currentWhere.ListingId)).length;
            if (currentWhere.OpenHouseOnly) {
                filterCounts++;
            }
            return filterCounts;
        };
        $scope.isPresetLocationSet = () => {
            return $scope.getPresetLocations().length > 0;
        };
        $scope.parsePresetLocationText = () => {
            const locations = $scope.getPresetLocations();
            $scope.presetLocationText = locations.join(', ');
            if (!isEmpty($scope.presetLocationText)) {
                const html = `<span>${locations.join('</span><span>')}</span>`;
                $scope.presetLocationHTML = $sce.trustAsHtml(html);
            }
            else {
                $scope.presetLocationHTML = null;
            }
            $scope.presetLocationsCountText = null;
            $scope.presetLocationsRemainingCountText = null;
            if (locations.length > 0) {
                $scope.presetLocationsCountText = `+${locations.length}`;
                if (locations.length > 2) {
                    $scope.presetLocationsRemainingCountText = `+${locations.length - 2}`;
                }
            }
            $scope.presetOtherFiltersCountText = null;
            const filterCounts = $scope.getOtherPresetFilterCount();
            if (filterCounts > 0) {
                $scope.presetOtherFiltersCountText = `+${filterCounts} Filter${filterCounts > 1 ? 's' : ''}`;
            }
        };
        $scope.focusElement = (selector) => {
            if (!isEmpty(selector)) {
                $timeout(() => {
                    const elementThis = $element[0];
                    const elementSelected = elementThis.querySelector(selector);
                    if (!elementSelected) {
                        console.warn('unable to find focusable element of', selector);
                        return;
                    }
                    elementSelected.focus();
                }, 100);
            }
        };
        $scope.variableSync = () => __awaiter(this, void 0, void 0, function* () {
            $scope.variableSyncing = $attrs.variableSync && isJSON($attrs.variableSync) ? JSON.parse($attrs.variableSync) : {};
            const promises = [];
            Object.keys($scope.variableSyncing).forEach((elementId) => {
                promises.push($q((resolve) => __awaiter(this, void 0, void 0, function* () {
                    const varElement = Idx.getInput(elementId);
                    if (varElement) {
                        const scopeVarPath = $scope.variableSyncing[elementId];
                        yield Idx.updateScopeValuePath($scope, scopeVarPath, varElement.val());
                        $scope.setWhere($scope.options.query.where);
                        $scope.$watch(scopeVarPath, (value) => {
                            if (isString(value) ||
                                isNumber(value) ||
                                isUndefined(value) ||
                                value == null) {
                                if (isUndefined(value)) {
                                    value = null;
                                }
                                varElement.val(value);
                            }
                            else {
                                varElement.val(JSON.stringify(value));
                            }
                            varElement[0].dispatchEvent(new Event('change'));
                        }, true);
                    }
                    resolve();
                })));
            });
            yield $q.all(promises);
        });
        $scope.canDisplayListingTypeButton = (listType) => {
            return $scope.options.forRent === listType.lease && $scope.options.selection.ListingType.group[listType.group];
        };
        $scope.inArray = (item, array) => includes(array, item);
        $scope.isIntersecting = (itemArray, array) => {
            if (!isArray(array) || !isArray(itemArray)) {
                console.warn('Array undefined, cannot search for', itemArray, 'in', array);
                return false;
            }
            return intersection(itemArray, array).length > 0;
        };
        $scope.toggleArrayElement = (item, array) => {
            array !== null && array !== void 0 ? array : (array = []);
            const arrayIndex = array.indexOf(item);
            if (arrayIndex >= 0) {
                array.splice(arrayIndex, 1);
            }
            else {
                array.push(item);
            }
        };
        $scope.showInlinePopup = (ev, menuElement) => {
            if (!$scope.filterMenu) {
                const position = $mdPanel.newPanelPosition()
                    .relativeTo(ev.srcElement)
                    .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
                const animation = $mdPanel.newPanelAnimation();
                animation.openFrom(position);
                animation.closeTo(position);
                animation.withAnimation($mdPanel.animation.FADE);
                const config = {
                    animation,
                    attachTo: element(document.body),
                    contentElement: menuElement,
                    position,
                    openFrom: ev,
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    focusOnOpen: false,
                    zIndex: 2
                };
                $scope.filterMenu = $mdPanel.create(config);
                $scope.filterMenu.reposition = function reposition() {
                    $timeout(() => {
                        $scope.filterMenu.updatePosition(position);
                    }, 100);
                };
            }
            $scope.filterMenu.open();
        };
        $scope.getMLSVariables = (reset) => {
            if (!mlsVariables || reset) {
                mlsVariables = {};
                Idx.getMLSVariables().forEach((service) => {
                    mlsVariables[service.id] = service;
                });
            }
            return Object.values(mlsVariables);
        };
        $scope.setQuery = (newQuery) => {
            var _a;
            newQuery !== null && newQuery !== void 0 ? newQuery : (newQuery = {});
            (_a = newQuery.where) !== null && _a !== void 0 ? _a : (newQuery.where = {});
            $scope.options.query = cloneDeep(newQuery);
            $scope.setWhere($scope.options.query.where);
        };
        $scope.setWhere = (newWhere) => {
            newWhere !== null && newWhere !== void 0 ? newWhere : (newWhere = {});
            $scope.options.query.where = extend(Idx.getDefaultWhereOptions(), newWhere);
            map(Idx.getDefaultWhereOptions(), (value, key) => {
                if (isArray(value) &&
                    Object.prototype.hasOwnProperty.call($scope.options.query.where, key) &&
                    !isArray($scope.options.query.where[key])) {
                    $scope.options.query.where[key] = [$scope.options.query.where[key]];
                }
            });
            $scope.parsePresetLocationText();
        };
        $scope.setWhereDefaults = () => {
            $scope.$applyAsync(() => {
                if ($scope.options.query.where.ListingType.length < 1) {
                    $scope.options.query.where.ListingType = $scope.options.selection.ListingType.default.Sale.Residential;
                    $scope.selectDefaultListingType();
                }
                lastQuery = cloneDeep($scope.options.query);
                $scope.parsePresetLocationText();
            });
        };
        $scope.selectDefaultListingType = (listingGroup) => {
            if (!listingGroup) {
                listingGroup = 'Commercial';
                if (!$scope.options.selection.ListingType.group.Commercial) {
                    listingGroup = 'Residential';
                }
            }
            $scope.options.query.where.ListingType = $scope.options.forRent ?
                $scope.options.selection.ListingType.default.Lease[listingGroup] :
                $scope.options.selection.ListingType.default.Sale[listingGroup];
            if ($scope.filterMenu) {
                $scope.filterMenu.reposition();
            }
            if ($scope.options.forRent) {
                $scope.options.query.where.Status = $scope.options.selection.Status.default.Lease;
            }
            else {
                $scope.options.query.where.Status = ($scope.options.query.where.Status && $scope.options.query.where.Status.length > 0) ?
                    $scope.options.query.where.Status : $scope.options.selection.Status.default.Lease;
            }
        };
        $scope.search = (force) => {
            if (!$scope.initialized) {
                console.warn($scope.uid, 'has not initialized and may not search yet');
                return;
            }
            let listScope;
            if ($scope.listId) {
                listScope = Idx.getListInstance($scope.listId);
            }
            if (listScope) {
                if (!$scope.throttledSearch) {
                    $scope.throttledSearch =
                        throttle(() => { listScope.search($scope.options.query, true); }, 600, { trailing: false });
                }
                $scope.throttledSearch();
            }
            else {
                if ($scope.hasQueryChanged() || force) {
                    lastQuery = cloneDeep($scope.options.query);
                    Idx.setUrlOptions('Search', $scope.options.query.where);
                    $window.open($scope.listLinkUrl + '#!' + Idx.getUrlOptionsPath(defaultQuery), $scope.listLinkTarget);
                }
            }
        };
        $scope.displayOfficeGroupSelector = (searchTerm, editIndex, ev) => {
            if (ev) {
                ev.preventDefault();
            }
            let searchOnLoad = false;
            const options = {
                query: {
                    perPage: 100
                }
            };
            if (!isEmpty(searchTerm) && isString(searchTerm)) {
                options.query.where = {
                    OfficeName: searchTerm
                };
                searchOnLoad = true;
            }
            if (!isNumber(editIndex)) {
                editIndex = $scope.options.officeGroups.length;
            }
            const template = '<md-dialog aria-label="Property Office Group Selector" class="transparent">' +
                '<md-button style="text-align: center" data-ng-click="close()">Close and Accept</md-button>' +
                '<stratus-idx-office-search' +
                ' data-template="search.group-selector"' +
                ` data-list-id="office-group-selector-${$scope.elementId}"` +
                ` data-options='${JSON.stringify(options)}'` +
                ` data-sync-instance="${$scope.elementId}"` +
                ` data-sync-instance-variable="options.officeGroups"` +
                ` data-sync-instance-variable-index="${editIndex}"` +
                '></stratus-idx-office-search>' +
                '<stratus-idx-office-list' +
                ` data-element-id="office-group-selector-${$scope.elementId}"` +
                ' data-template="list.empty"' +
                ` data-search-on-load="${searchOnLoad}"` +
                ` data-query='${JSON.stringify(options.query)}'` +
                ` data-query-service="${$scope.options.query.service}"` +
                '></stratus-idx-office-list>' +
                '</md-dialog>';
            $mdDialog.show({
                template,
                parent: element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: true,
                controllerAs: 'ctrl',
                controller: ($scope, $mdDialog) => {
                    const dc = this;
                    dc.$onInit = () => {
                        dc.close = close;
                    };
                    function close() {
                        if ($mdDialog) {
                            $mdDialog.hide();
                        }
                    }
                    $scope.close = close;
                }
            })
                .then(() => {
                $scope.validateOfficeGroups();
            }, () => {
                $scope.validateOfficeGroups();
            });
        };
        $scope.validateOfficeGroups = (search) => {
            $scope.options.officeGroups = $scope.options.officeGroups.filter((selection) => {
                return (!isEmpty(selection.name) && !isEmpty(selection.group));
            });
            const officeNumbers = [];
            $scope.options.query.where.OfficeNumber = [];
            $scope.options.officeGroups.forEach((selection) => {
                officeNumbers.push(...selection.group);
            });
            $scope.options.query.where.OfficeNumber = officeNumbers;
            if (search) {
                $scope.search();
            }
        };
        $scope.refreshSearchWidgetOptions = (listScope) => __awaiter(this, void 0, void 0, function* () {
            if (!listScope &&
                $scope.listId) {
                listScope = Idx.getListInstance($scope.listId);
            }
            if (listScope) {
                $scope.setQuery(listScope.query);
                lastQuery = cloneDeep($scope.options.query);
                $scope.listInitialized = true;
            }
        });
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.hasQueryChanged = () => !isEqual(clone(lastQuery), clone($scope.options.query));
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=search.component.js.map
